import {Link} from '@primer/react'
import {useSidebarActivityOpenTimeline} from './use-sidebar-activity-open-timeline'

export function FullTimelineLink() {
  const openTimeline = useSidebarActivityOpenTimeline()

  return (
    <Link
      as="button"
      inline
      className="color-fg-muted text-small mt-1 text-left"
      onClick={event => openTimeline(event.currentTarget)}
    >
      Full timeline
    </Link>
  )
}
